import React, { Component } from "react";
import ArticleCard from "./Articles/ArticleCard";
import { CardDeck } from 'reactstrap';

class ArticleCollection extends Component {
  render() {

    var homeStyle = {
      paddingTop: "65px"
    };

    var cardDeckStyle = {
        backgroundColor: "black",
        padding: 10,
        marginBottom: 10,
        borderStyle: "solid",
        borderColor: "darkslategray"
    }

    var comingSoonStyle = {
       paddingTop: 10,
       paddingBottom: 10,
       marginTop: 10,
       marginBottom: 10,
       backgroundColor: "black",
       borderStyle: "solid",
       borderColor: "darkslategray"

    }

    var h3Style = {
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    }

    return (
      <div className="Site-content" style={homeStyle} >
        <div className="container">
        <div style={comingSoonStyle} className="row justify-content-center rounded">
          <h3 style={h3Style}>Nova Blitz HQ Articles</h3>
        </div>
        </div>


        <div className="container">
        <CardDeck id="articles" className="d-flex justify-content-center rounded" style={cardDeckStyle}>
          <ArticleCard page={"articles"} type={"hq"}/>
        </CardDeck>
        </div>


        <div className="container">
        <div style={comingSoonStyle} className="row justify-content-center rounded">
          <h3 style={h3Style}>Off Site Links</h3>
        </div>
        </div>


        <div className="container">
        <CardDeck id="articles" className="d-flex justify-content-center rounded" style={cardDeckStyle}>
          <ArticleCard page={"articles"} type={"links"}/>
        </CardDeck>
        </div>

      </div>

    );
  }
}

export default ArticleCollection;



// WEBPACK FOOTER //
// ./src/ArticleCollection.js